"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Check } from "lucide-react";
export default function ComplianceSecurityHighlights() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const compliancePoints = ["HIPAA awareness and compliance support", "Business Associate Agreements (BAAs) available", "Secure handling of protected health information", "Data confidentiality protocols in place", "Regular security training for all team members"];
  return <section id="compliance-security-highlights" ref={ref} className="bg-background py-16 px-6 md:px-12 lg:px-20 relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none bg-[repeating-linear-gradient(0deg,_hsl(210,_80%,_55%)_0px,_hsl(210,_80%,_55%)_1px,_transparent_1px,_transparent_20px),_repeating-linear-gradient(90deg,_hsl(210,_80%,_55%)_0px,_hsl(210,_80%,_55%)_1px,_transparent_1px,_transparent_20px)]" />

      <div className={`max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 transition-all duration-[150ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        {}
        <div className="space-y-6">
          <h2 className="font-display font-semibold text-3xl md:text-4xl text-foreground mb-8">
            Compliance & Security
          </h2>
          <ul className="space-y-5">
            {compliancePoints.map((point, i) => <li key={i} data-index={i} className="flex items-start gap-4 group">
                <div className={`flex-shrink-0 w-6 h-6 rounded-full bg-primary flex items-center justify-center transition-all duration-[150ms] ease-out ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-50"}`} style={{
              transitionDelay: isVisible ? `${i * 80}ms` : "0ms"
            }}>
                  <Check className="w-4 h-4 text-foreground-primary" />
                </div>
                <span className={`text-foreground text-base md:text-lg leading-relaxed transition-all duration-[150ms] ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-2"}`} style={{
              transitionDelay: isVisible ? `${i * 80 + 50}ms` : "0ms"
            }}>
                  {point}
                </span>
              </li>)}
          </ul>
        </div>

        {}
        <div className="flex items-center">
          <div className={`border-2 border-border-strong rounded-lg p-8 bg-white shadow-soft transition-all duration-[150ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
          transitionDelay: isVisible ? "200ms" : "0ms"
        }}>
            <p className="text-foreground text-base md:text-lg leading-relaxed">
              At AJ Dynasty Smart Behavioral Solution, we prioritize the security and confidentiality of your data. 
              Our administrative support services are designed with compliance at the core, ensuring that all protected 
              health information is handled according to industry standards and regulations. We work closely with our 
              clients to maintain trust and uphold the highest ethical practices in every aspect of our operations.
            </p>
          </div>
        </div>
      </div>
    </section>;
}